import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home')
  },
  {
    path: '/oss2026docs',
    name: 'oss2026docs',
    component: () => import(/* webpackChunkName: "oss2026docs" */ '../views/Oss2026docs')
  },
  // {
  //   path: '/',
  //   name: 'oss',
  //   component: () => import(/* webpackChunkName: "oss" */ '../views/Oss/')
  // },
  {
    path: '/panel',
    name: 'panel',
    component: () => import(/* webpackChunkName: "panel" */ '../views/Panel/'),
    children: [
      {
        path: 'home',
        name: 'panelHome',
        meta: {title: 'Мой Вольный - Панель'},
        components: {
          subcomponent: () => import(/* webpackChunkName: "panel" */ '../views/Panel/Home'),
          default: () => import(/* webpackChunkName: "panel" */ '../views/Panel/'),
        }
      },
      {
        path: 'docs',
        name: 'panelDocs',
        meta: {title: 'Памятка собственнику - Панель'},
        components: {
          default: () => import(/* webpackChunkName: "panel" */ '../views/Panel/'),
          subcomponent: () => import(/* webpackChunkName: "panel" */ '../views/Panel/Docs'),
        }
      },
      {
        path: 'admin',
        name: 'panelAdmin',
        meta: {title: 'Управление комплексом - Панель'},
        components: {
          default: () => import(/* webpackChunkName: "panel" */ '../views/Panel/'),
          subcomponent: () => import(/* webpackChunkName: "admin" */ '../views/Panel/Admin'),
        },
        children: [
          {
            path: 'role',
            name: 'panelAdminRole',
            meta: {title: 'Роли - Админка - Панель'},
            components: {
              default: () => import(/* webpackChunkName: "panel" */ '../views/Panel/'),
              subcomponent: () => import(/* webpackChunkName: "admin" */ '../views/Panel/Admin'),
              subcomponent2: () => import(/* webpackChunkName: "admin" */ '../views/Panel/Admin/Role/List'),
            }
          },
          {
            path: 'user',
            name: 'panelAdminUser',
            meta: {title: 'Пользователи - Админка - Панель'},
            components: {
              default: () => import(/* webpackChunkName: "panel" */ '../views/Panel/'),
              subcomponent: () => import(/* webpackChunkName: "admin" */ '../views/Panel/Admin'),
              subcomponent2: () => import(/* webpackChunkName: "admin" */ '../views/Panel/Admin/User/List'),
            }
          },
          {
            path: 'apartment',
            name: 'panelAdminApartment',
            meta: {title: 'Помещения - Админка - Панель'},
            components: {
              default: () => import(/* webpackChunkName: "panel" */ '../views/Panel/'),
              subcomponent: () => import(/* webpackChunkName: "admin" */ '../views/Panel/Admin'),
              subcomponent2: () => import(/* webpackChunkName: "admin" */ '../views/Panel/Admin/Apartment/List'),
            }
          },
          {
            path: 'document',
            name: 'panelAdminDocument',
            meta: {title: 'Документы - Админка - Панель'},
            components: {
              default: () => import(/* webpackChunkName: "panel" */ '../views/Panel/'),
              subcomponent: () => import(/* webpackChunkName: "admin" */ '../views/Panel/Admin'),
              subcomponent2: () => import(/* webpackChunkName: "admin" */ '../views/Panel/Admin/Document/List'),
            }
          },
          {
            path: 'oss',
            name: 'panelAdminOSS',
            meta: {title: 'ОСС - Админка - Панель'},
            components: {
              default: () => import(/* webpackChunkName: "panel" */ '../views/Panel/'),
              subcomponent: () => import(/* webpackChunkName: "admin" */ '../views/Panel/Admin'),
              subcomponent2: () => import(/* webpackChunkName: "admin" */ '../views/Panel/Admin/OSS/List'),
            }
          },
        ]
      },
    ]
  },
]

const router = new VueRouter({
  scrollBehavior(to, from) {
    return { x: 0, y: 0 }
  },
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  if (to.meta.title){
    if (typeof to.meta.title=='function'){
      document.title = to.meta.title(to) + ' - ' + process.env.VUE_APP_TITLE
    }else{
      document.title = to.meta.title + ' - ' + process.env.VUE_APP_TITLE
    }
  }else{
    document.title = process.env.VUE_APP_TITLE
  }
  next()
})

export default router
